import React from 'react';

import { addWithConfig } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import ActionButtonLink from 'components/action-button';
import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

const styles = StyleSheet.create({
  emptyScreenWrapper: {
    alignItems: 'center',
    flex: 1,
    marginTop: spacing.$3,
  },
  headerText: {
    margin: 0,
  },
  imageWrapper: {
    alignItems: 'center',
    marginBottom: spacing.$12,
    maxHeight: spacing.$64,
    width: '100%',
  },
});

export const EmptyScreenWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.emptyScreenWrapper, style] });

export const StyledActionButtonLink = addWithConfig(ActionButtonLink).withConfig({
  style: { marginTop: spacing.$4 },
  width: '$80',
});

export const HeaderText = withTypography({
  variant: 'headerOne',
  fontSize: 'xl',
  lineHeight: 'md',
  style: styles.headerText,
});

export const SubText = withTypography({
  variant: 'copyOne',
  mt: '$4',
  mx: '$8',
  mb: '$0',
  fontSize: 'md',
  textAlign: 'center',
});

export const ImageWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.imageWrapper, style] });
